var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.userInfo)?_c('logined'):_c('un-login')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }